import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import FloatingLabelSelect from '../ui/FloatingLabelSelect';
import { fetchClientData } from '../../services/adminApiService';
import { fetchUserDataByRole,fetchRoleData  } from '../../services/client/reportApiService';

const UserUserPermission = () => {
  const [isEditing, setIsEditing] = useState(false);
    const [apiResponse, setApiResponse] = useState(null);
  const [clients, setClients] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);

  const [selectedRole, setSelectedRole] = useState(""); // Filter role
  const [selectedUsers, setSelectedUsers] = useState([]); // Selected users

  const [userRoles, setUserRoles] = useState([]);

  //const [filteredUsers, setFilteredUsers] = useState([]);


  // Initialize formValues state to include clientId and rolePermissions
  const [formValues, setFormValues] = useState({
    clientId: '', 
    roleId: '',
    userId: '', 
    userPermissions: [] // Initially empty
  });

  const [errors, setErrors] = useState({});
  const [selectAllChecked, setSelectAllChecked] = useState(false); // State for "Check All" checkbox

    // Simple validation function
    const validate = () => {
        const newErrors = {};
        if (!formValues.clientId) newErrors.clientId = 'Organization is required';
        if (!formValues.userId) newErrors.userId = 'User is required';
        return newErrors;
    };

    const handleBlur = (field) => {
        const validationErrors = validate();
        setErrors(validationErrors);
    };

    const getClients = async () => {
        try {
            const clientData = await fetchClientData();
            setClients(clientData.map(client => ({ value: client.clientId, label: client.clientName })));
        } catch (error) {
            console.error("Error fetching countries:", error);
        }
    };

    const inputClasses = (field) =>
        errors[field] ? 'border-red-500' : 'border-gray-300';


    useEffect(() => {
        getClients();
    }, []);


      const getUsers = async (clientId,roleId) => {
          try {
              const userData = await fetchUserDataByRole(clientId,roleId);
              // setUsers(userData.map(user => ({ value: user.userId, label: user.userName })));
              setUsers(userData.map(user => ({ userId: user.userId, userName: user.userName, roleId: user.roleId, roleName: user.roleName })));
              const uniqueRoles = [...new Set(userData.map((user) => user.roleName))];
              setUserRoles(uniqueRoles);
              
    //setFilteredUsers(filteredUsers1);

      
             
          } catch (error) {
              console.error("Error fetching clients:", error);
          }
      };

      const fetchRolesByClient = async (clientId) => {
        try {
            const roleData = await fetchRoleData(clientId);
            setRoles([{ value: -1, label: 'All' }, ...roleData.map(role => ({ value: role.roleId, label: role.roleName }))]);
        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };

  // Handle client selection
  const handleClientChange = (option) => {
    const selectedClientId = option.value;
    setFormValues({ ...formValues, clientId: option.value, userId: '' }); 
    fetchRolesByClient(selectedClientId);
  };

  // Handle Role selection
  const handleRoleChange = (option) => {
    const selectedRoleId = option.value;
    getUsers(formValues.clientId,selectedRoleId);
    setFormValues({
      ...formValues,
      roleId: selectedRoleId
    });
  };


  const toggleUserSelection = (userId) => {
    setSelectedUsers((prevSelected) =>
      prevSelected.includes(userId)
        ? prevSelected.filter((id) => id !== userId)
        : [...prevSelected, userId]
    );
  };

  const filteredUsers = selectedRole
  ? users.filter((user) => user.roleName === selectedRole)
  : users;
  return (
    <div  className="container mx-auto p-6">
            <div><h3>User Role Permissions</h3></div>
    <div className="container mx-auto p-6 bg-white rounded-lg border">
        <form  className="space-y-6 w-full">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                        {loading ? (
                            <p>Loading countries...</p>
                        ) : (
                            <FloatingLabelSelect
                                label="Select Organization"
                                id="clientId"
                                name="clientId"
                                value={clients.find(client => client.value === formValues.clientId) || null} // Handle no selection case with null
                                onChange={handleClientChange}//,{(option) => setFormValues({ ...formValues, clientId: option.value })}
                                onBlur={() => handleBlur('clientId')}
                                className={inputClasses('clientId')}
                                options={clients}
                                isSearchable={true}
                            />
                        )}
                        {errors.clientId && <div className="text-red-500 text-sm">{errors.clientId}</div>}
                    </div>
                    <div>
                                    <>
                                        {loading ? (
                                            <p>Loading states...</p>
                                        ) : (
                                            <FloatingLabelSelect
                                                label="Select Role"
                                                id="roleId"
                                                 name="roleId"
                                                value={roles.find(role => role.value === formValues.roleId) || null} // Use null if no state is selected
                                                onChange={handleRoleChange}
                                               
                                                onBlur={() => handleBlur('roleId')}
                                                className={inputClasses('roleId')}
                                                options={roles}
                                                isSearchable={true}
                                            />

                                        )}
                                    </>
                                    {errors.roleId && <div className="text-red-500 text-sm">{errors.roleId}</div>}
                                    </div>
                    <div>
                        {/* Users Dropdown */}
                        {loading ? (
                            <p>Loading Users...</p>
                        ) : (
                            <FloatingLabelSelect
                                label="Select User"
                                id="userId"
                                name="userId"
                                value={users.find(user => user.value === formValues.userId) || null}
                                onChange={(option) => setFormValues({ ...formValues, userId: option.value })}
                                className="input-class"
                                options={users} // Including 'All Clients' option
                                isSearchable={true}
                            />
                        )}
                        {errors.userId && <div className="text-red-500 text-sm">{errors.userId}</div>}
                    </div>
                                
                </div>
      
                {userRoles && (
                <div className="p-6">
                
          
                {userRoles.map((role, index) => {
                  const usersUnderRole = filteredUsers.filter(
                    (user) => user.roleName === role
                  );
          //console.log(`Users Under Roles${role} , ${JSON.stringify(filteredUsers)}`);
                  if (usersUnderRole.length === 0) return null;
          
                  return (
                    <div key={`${role}-${index}`} className="mb-6">
                      <h3 className="text-lg font-semibold text-gray-800 mb-3">{role}</h3>
                      {usersUnderRole.map((user) => (
                        <div key={user.userId} className="flex items-center mb-2">
                          <input
                            type="checkbox"
                            id={`user-${user.userId}`}
                            className="h-4 w-4 text-indigo-600 border-gray-300 rounded"
                            checked={selectedUsers.includes(user.userId)}
                            onChange={() => toggleUserSelection(user.userId)}
                          />
                          <label
                            htmlFor={`user-${user.userId}`}
                            className="ml-2 text-sm text-gray-700"
                          >
                            {user.userName}
                          </label>
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
    )}
      </form>
      {apiResponse && (
                    <motion.div
                        className={`mt-4 flex items-center ${apiResponse.error ? 'text-red-500' : 'text-green-500'}`}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        {apiResponse.error ? (
                            <>
                                <FaExclamationCircle className="mr-2" />
                                {apiResponse.error}
                            </>
                        ) : (
                            <>
                                <FaCheckCircle className="mr-2" />
                                {apiResponse.success}
                            </>
                        )}
                    </motion.div>
                )}
    </div>
    </div>
  );
};



export default UserUserPermission;
